import { SharedModule } from './../shared/shared.module';
import { QuizModule } from './../quiz/quiz.module';
import { DataTablesModule } from 'angular-datatables';
import { RouterModule } from '@angular/router';
import { SubscriptionGroupShowComponent } from '../guardian/group/subscription-group-show/subscription-group-show.component';
import { SubscriptionGroupEditComponent } from '../guardian/group/subscription-group-edit/subscription-group-edit.component';


import { SubscriptionGroupingEditComponent } from '../guardian/group/subscription-grouping-edit/subscription-grouping-edit.component';
import { SubscriptionGroupingIndexComponent } from '../guardian/group/subscription-grouping-index/subscription-grouping-index.component';
import { SubscriptionGroupIndexComponent } from './subscription-group-index/subscription-group-index.component';
import { ReactiveFormsModule } from '@angular/forms';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavGroupingQuizListComponent } from './nav/nav-grouping-quiz-list/nav-grouping-quiz-list.component';
import { NavGroupingChangeQuizAreaComponent } from './nav/nav-grouping-change-quiz-area/nav-grouping-change-quiz-area.component';
import { NavGroupingStudentIndexComponent } from './nav/nav-grouping-student-index/nav-grouping-student-index.component';
import { SubscriptionGroupingQuizListComponent } from '../guardian/group/subscription-grouping-quiz-list/subscription-grouping-quiz-list.component';

import { SubscriptionGroupingModifySubtopicComponent } from '../guardian/group/subscription-grouping-modify-subtopic/subscription-grouping-modify-subtopic.component';
import { SubscriptionGroupingQuizAreaModifyComponent } from '../guardian/group/subscription-grouping-quiz-area-modify/subscription-grouping-quiz-area-modify.component';


@NgModule({
  declarations: [
    SubscriptionGroupIndexComponent,

  ],
  imports: [
    CommonModule,
    RouterModule,
    QuizModule,
    ReactiveFormsModule,
    DataTablesModule,
    SharedModule
  ]
})
export class GroupsModule { }
